import React, {useState, useEffect} from 'react'
import Layout from '../../components/Layout/Layout'
import axios from 'axios'
import toast from 'react-hot-toast';
import { useAuth } from '../../context/auth';
import { Link } from 'react-router-dom';
import { FaTrashAlt} from "react-icons/fa";
import {Button, Form,Spinner } from 'react-bootstrap';
import { Typeahead } from 'react-bootstrap-typeahead';
import 'react-bootstrap-typeahead/css/Typeahead.css';
import { SERVER_API } from '../../fileWithConstants';
import { dateInDMY } from '../../Helpers';
import FabricTransferModal from './FabricTransferModal';
const ThanTransferFromWarehouse = () => {
 const[auth, setAuth] =useAuth();
 const[userId, setUserId]=useState(auth.user.id);
const [finalSelectedFabrics, setFinalSelectedFabrics] = useState([]);
const [thanFabrics, setThanFabrics] = useState([]);
const [categoryName, setCategoryName] = useState({});
const [supplierName, setSupplierName] = useState([]);
const [thanDatashow, setThanDatashow] = useState(false);
const [loading, setLoading] = useState(false);

/* for search */
const [options, setOptions] = useState([]);
const [isLoading, setIsLoading] = useState(false);
const [isTransferring, setIsTransferring] = useState(false);

/* new states */
const [warehouse, setWarehouse] = useState([]);
const [transferWarehouse, setTransferWarehouse] = useState([]);

const [selectedWarehouse, setSelectedWarehouse] = useState('');
const [selectedWarehouseTrans, setSelectedWarehouseTrans] = useState('');


const [selected, setSelected] = useState([]);
const [formValidated, setFormValidated] = useState(false);
const [errors, setErrors] = useState({});

const handleTransferSubmit = async (event) => {
  event.preventDefault();

  if (!selectedWarehouseTrans) {
    alert('Please select the target warehouse for transfer.');
    return;
  }

  const final_fab_ids = finalSelectedFabrics
    .filter((item) => item.id)
    .map((item) => item.id);

  if (final_fab_ids.length === 0) {
    alert('No fabrics selected to transfer.');
    return;
  }

  try {
    console.log('Submitting transfer...');
    setIsTransferring(true);

    const payload = {
      fabric_ids: final_fab_ids,
      from_warehouse: selectedWarehouse,
      to_warehouse: selectedWarehouseTrans,
      user_id: userId,
    };

    const { data } = await axios.post(`${SERVER_API}/api/v1/fabric/fabric-than-transfer`, payload);

    if (data.success) {
      toast.success(data.message || 'Transfer completed successfully.');
      // Reset selections if needed:
      setFinalSelectedFabrics([]);
      setSelectedWarehouseTrans('');
    } else {
      toast.error(data.message || 'Transfer failed.');
    }
  } catch (error) {
    console.error('Transfer failed:', error);
    toast.error(error.response?.data?.message || 'Error while submitting transfer.');
  } finally {
    setIsTransferring(false);
  }
};



const handleSubmit = async (event) => {
  event.preventDefault();

  const newErrors = {};
  if (!selectedWarehouse) {
    newErrors.warehouse = 'Please select a warehouse.';
  }
  if (selected.length === 0) {
    newErrors.fabrics = 'Please select at least one fabric.';
  }

  setErrors(newErrors);
  setFormValidated(true);

  if (Object.keys(newErrors).length === 0) {
    try {
      setLoading(false);
      const payload = {
        warehouse_id: selectedWarehouse,
        fabric_ids: selected.map(fb => fb.id),
      };
      //console.log(payload); return false;
      const { data } = await axios.get(`${SERVER_API}/api/v1/fabric/get-fabric-transfer-data`, {
                        params: payload,
                      });
     // console.log(data); return false;

     if(data?.success && data?.fabrics.length>0){
 
      setThanFabrics(data?.fabrics);
      setThanDatashow(true);
      setLoading(false);
    }else{
      setLoading(false);
      //toast.error('Some thing went wrong while getting fabric data.')
    }
    } catch (error) {
      console.error('Submit error:', error);
      toast.error('Something went wrong while submitting.');
    }
  }
};

  const getAllSupplier = async()=>{
    try {
      const {data} = await axios.get(`${SERVER_API}/api/v1/supplier/get-all-supplier`);
      if(data?.success && data?.suppliers?.length>0){
        const all_sup = data?.suppliers;
        const supp_key_val={};
        all_sup?.forEach((s)=>{
          supp_key_val[s.v_id]=s.code;
        })
        setSupplierName(supp_key_val);
      }
    } catch (error) {
      console.log(error)
    }
  }

  useEffect(()=>{
    getAllSupplier();
  },[])

const searchFabric = async (query) => {
    if (query.length > 3) {
      setIsLoading(true);
      try {
        const { data } = await axios.get(`${SERVER_API}/api/v1/fabric/get-fabric-search/${query}`);
        if (data.success) {
          setOptions(data.fabrics);
        }
      } catch (err) {
        console.error('Fabric search error:', err);
      } finally {
        setIsLoading(false);
      }
    }
  };

/* new code */
useEffect(()=>{
    getWareHouse();
},[])

const handleAddSelectedFabrics = (selectedFabrics) => {
  // You can update state, combine, filter duplicates, etc.
  //setFinalSelectedFabrics((prev) => [...prev, ...selectedFabrics]);
  setFinalSelectedFabrics((prev) => {
        const allFabrics = [...prev, ...selectedFabrics];
        // Create a Map to remove duplicates based on `id`
        const uniqueFabricsMap = new Map();
        allFabrics.forEach(fb => {
          //if(fb.warehouse===selectedWarehouse){}
          uniqueFabricsMap.set(fb.id, fb);
        });

        return Array.from(uniqueFabricsMap.values());
      });


  console.log('Received from modal:', selectedFabrics);
};

 const getWareHouse = async()=>{
        try {
            const {data} = await axios.get(`${SERVER_API}/api/v1/supplier/get-warehouse`);
            if(data?.success && data?.wdata.length>0){
                /* console.log(data) */
                setWarehouse(data?.wdata);
            }else{
              toast.error('Some thing went wrong while getting Warehouse data.')
            }
        } catch (error) {
            console.log(error)
        }
    }


const getAllFabricCategory = async()=>{
    try {
      const {data} = await axios.get(`${SERVER_API}/api/v1/fabric/get-fabric-category`);
      if(data?.success){
        const all_cat = data?.category;

        const cat_key_val={};
        all_cat?.forEach((c)=>{
          cat_key_val[c.id]=c.name;
        })
        setCategoryName(cat_key_val);
      }
    } catch (error) {
      console.log(error)
    }
  }

  useEffect(()=>{
    getAllFabricCategory();
    //getTotal();
  },[])

  const handleRemoveFabric = (id) => {
  setFinalSelectedFabrics(prev => prev.filter(fb => fb.id !== id));
};

// 
const handleWarehouseChange = (warehouse_id) => {
  if (finalSelectedFabrics.length > 0) {
      const conf = window.confirm('If you change warehouse, all fabric you have added will be removed.');
      if (conf) {
        setFinalSelectedFabrics([]);
        setSelectedWarehouse(warehouse_id);
        setSelected([]);

        let transW = warehouse?.filter((item) => item.id!=warehouse_id);
        setTransferWarehouse(transW)

        let newfinalSelectedFabrics = finalSelectedFabrics.filter((item)=>item.warehouse===warehouse_id);
        setFinalSelectedFabrics(newfinalSelectedFabrics);
      }
    } else {
      setSelectedWarehouse(warehouse_id);
      let transW = warehouse?.filter((item) => item.id!=warehouse_id);
      setTransferWarehouse(transW)
    }
};



  return (
    <Layout title={'Thaan transfer from warehouse'}>
        <div className='container'>
            <h1 className='page-title'>Thaan transfer from warehouse</h1>
            {/* ----Transfer from=={ JSON.stringify(selectedWarehouse) }---
             ----Transfer =={ JSON.stringify(selectedWarehouseTrans) }---
              ===={JSON.stringify(finalSelectedFabrics)}===  */}
                <div className="row">
                  <div className="col-md-12">
                    <Form noValidate validated={formValidated} onSubmit={handleSubmit} className="mt-3">
                      <div className="row align-items-center justify-content-center">
                        {/* Warehouse Select */}
                        <div className="col-md-2">
                          <Form.Group controlId="warehouseSelect">
                            <Form.Control
                              as="select"
                              value={selectedWarehouse}
                              onChange={(e) => handleWarehouseChange(e.target.value)}
                              isInvalid={!!errors.warehouse}
                            >
                              <option value="">-- From Warehouse --</option>
                              {warehouse?.map((house, index) => (
                                <option key={index} value={house.id}>{house.name}</option>
                              ))}
                            </Form.Control>
                            <Form.Control.Feedback type="invalid">
                              {errors.warehouse}
                            </Form.Control.Feedback>
                          </Form.Group>
                        </div>

                        {/* Typeahead Search */}
                        <div className="col-md-3">
                          <Form.Group controlId="fabricSearch">
                            <Typeahead
                              multiple
                              id="checkbox-typeahead"
                              labelKey="name"
                              onInputChange={(query) => searchFabric(query)}
                              onChange={(selectedItems) => setSelected(selectedItems)}
                              options={options}
                              selected={selected}
                              isLoading={isLoading}
                              placeholder="Search and select fabrics..."
                            />
                            {errors.fabrics && (
                              <div className="text-danger small mt-1">{errors.fabrics}</div>
                            )}
                          </Form.Group>
                        </div>

                        {/* Submit Button */}
                        <div className="col-md-2 d-flex align-items-end">
                          <Button type="submit" variant="primary" className="w-100">
                            {isLoading ? <Spinner animation="border" size="sm" /> : 'Add to Transfer'}
                          </Button>
                        </div>

                      </div>
                    </Form>
                  </div>
                </div>

            
            <div className='col-md-12 mt-3'>
            <div className='table-box'>
            <table className="table table-responsive table-hover table-sticky">
            <thead>
            <tr>
            <th scope="col">#</th>
            <th scope="col" className='text-start'>Name</th>
            <th scope="col" className='text-start'>Supplier Fabric Name</th>
            <th scope="col">Photo</th>
            <th scope="col">Category</th>
            <th scope="col">Supplier</th>
            <th scope="col">Warehouse</th>
            <th scope="col">Thaan No.</th>
            <th scope="col">Action</th>
            </tr>
            </thead>
            <tbody>
            
            { finalSelectedFabrics && finalSelectedFabrics.map((fb, index)=>(
              <tr key={fb.id}>
                <td>{index + 1}</td>
                <td className='text-start'>{fb.name}</td>
                <td>{fb.supplierfbname}</td>
                <td>
                {fb.fabric_photo!==''?(
                  <Link to={`${SERVER_API}/uploads/fabrics/${fb.fabric_photo}`} target='_blank'>
                  <img
                  src={`${SERVER_API}/uploads/fabrics/${fb.fabric_photo}`}
                  alt={fb.name}
                  width="50"
                />
                  </Link>
                )
                  :("")
                }
               
                </td>
                <td className='text-start'>{categoryName[fb.category]}</td>
                <td>{supplierName[fb.supplier]}</td>
                <td>{fb.warehouse_name}</td>
                <td>{fb.than_no}</td>
                <td>
                  <button
                    type="button"
                    onClick={() => handleRemoveFabric(fb.id)}
                    style={{
                      background: 'none',
                      border: 'none',
                      color: 'red',
                      cursor: 'pointer',
                      padding: 0
                    }}
                    title="Remove"
                  >
                    <FaTrashAlt />
                  </button>
                </td>
                </tr>
            )) }

            </tbody>
            </table>
            </div>
            </div>
            
            {finalSelectedFabrics.length>0 && (
              <div className="row">
              <Form
                noValidate
                validated={formValidated}
                onSubmit={handleTransferSubmit}
                className="mt-3"
              >
                <div className="row align-items-center justify-content-center">

                  <div className="col-md-2">
                    <Form.Control
                      as="select"
                      value={selectedWarehouseTrans}
                      onChange={(e) => setSelectedWarehouseTrans(e.target.value)}
                      isInvalid={!!errors.warehouse}
                    >
                      <option value="">-- To Warehouse --</option>
                      {transferWarehouse?.map((house, index) => (
                        <option key={index} value={house.id}>
                          {house.name}
                        </option>
                      ))}
                    </Form.Control>
                    <Form.Control.Feedback type="invalid">
                      {errors.warehouse}
                    </Form.Control.Feedback>
                  </div>
                  <div className="col-md-2">
                    <Button type="submit" variant="primary">
                       {isTransferring ? <><Spinner animation="border" size="sm" /> {`Transferring...`}</> : 'Transfer'}
                    </Button>
                  </div>
                </div>

              </Form>
            </div>
            )}
        </div>
      
        <FabricTransferModal 
        thanDatashow={thanDatashow}
        handleClose={() => setThanDatashow(false)}
        thanFabrics={thanFabrics}
        dateInDMY={(date) => dateInDMY(date)}
        onAddSelected={handleAddSelectedFabrics}
        />
    </Layout>
  )
}

export default ThanTransferFromWarehouse